import React from 'react';
import { Link } from 'react-router-dom';
import FlightDeal from '../FlightDeals/FlightDeals';
import '../Destination/Destination.css';

const destinations = [
  { id: "indian-ocean", city: "Indian Ocean", business: "£1840", first: "£3040" },
  { id: "canada", city: "Canada", business: "£1680", first: "£2800" },
  { id: "far-east", city: "Far East", business: "£1760", first: "£2880" },
  { id: "new-zealand", city: "New Zealand", business: "£2320", first: "£3360" },
  { id: "australia", city: "Australia", business: "£2235", first: "£3256" },
  { id: "south-america", city: "South America", business: "£1920", first: "£2960" },
  { id: "usa", city: "USA", business: "£1600", first: "£2720" },
  { id: "caribbean", city: "Caribbean", business: "£1560", first: "£2640" },
  { id: "south-africa", city: "South Africa", business: "£2000", first: "£3120" },
  { id: "middle-east", city: "Middle East", business: "£1440", first: "£2480" },
];



const Destination = () => {
  return (
    <>
      <FlightDeal bgClass="bg-destination" />

      <div className="destination-container">
        <h2 className="destination-heading">Experience These Incredible Destinations</h2>
        <div className="destination-content">
          <div className="destination-list">
            <table>
              <thead>
                <tr>
                  <th>City</th>
                  <th>Business Class</th>
                  <th>First Class</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {destinations.map((item) => (
                  <tr key={item.id}>
                    <td>{item.city}</td>
                    <td>from {item.business}</td>
                    <td>from {item.first}</td>
                    <td>
                      <Link to={`/destination/${item.id}`}>Know More &gt;</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
        </div>
        <div className="destination-info">
  <h3>Explore Our Travel Destinations</h3>
  <p>
    We offer flights to some of the most sought-after destinations worldwide.  
  </p>
  <p>
    Can't find your preferred location? Reach out to us, and we'll provide the details you need.  
  </p>
  <p>Contact us today for exclusive last-minute deals!</p>
  <div className="destination-logos">
    <img src="/protected.png" alt="Gold Trusted Service 2018" />
    {/*-
    <img src="/goldtrusted.png" alt="Gold Trusted Service 2023" />
    -*/}
  </div>
</div>

      </div>
    </div>
    </>
  )
}

export default Destination